export interface LastAssociationDeviceVehicle {
  vehicleId: string | null;
  licensePlate: string | null;
  model: {
    name: string | null;
    brand: string | null;
  } | null;
  fleetId: string;
  associatedAt: string;
  deviceId: string;
  deviceType: string;
  cobliId: string;
}

export interface DevolutionInformationDeviceInformation {
  devolutionDevicesCobliIds: [string];
  devolutionDevicesIds: [string];
  devolutionDevicesEsn: string | null;
  lightDevolutionInstalledBlockerQuantity: number | null;
  heavyOrLightDevolutionInstalledQuantity: number | null;
  heavyOrLightDevolutionInstalledBuzzerQuantity: number | null;
  heavyOrLightDevolutionInstalledCoblicamQuantity: number | null;
  heavyOrLightDevolutionInstalledImmobilizerQuantity: number | null;
  motorcycleOrMachineryDevolutionInstalledQuantity: number | null;
  lightDevolutionRemovableQuantity: number | null;
  heavyDevolutionRemovableQuantity: number | null;
  heavyOrLightDevolutionRemovableBuzzerQuantity: number | null;
  heavyOrLightDevolutionRemovableIdentifierQuantity: number | null;
  motorcycleOrMachineryDevolutionInstalledClientQuantity: number | null;
  heavyOrLightDevolutionInstalledIdentifierQuantity: number | null;
}

export interface CrmTicketDto {
  id: string;
  originTicketId: string | null;

  shippingInformation: {
    trackingCode: string | null;
    shippingCompany: string | null;
    shippingCompanyLink: string | null;
    address: string | null;
    estimatedReceivingDate: string | null;
    deviceInformation: {
      quantidadeEnvioInstaladoLevesBloqueador?: number;
      quantidadeEnvioInstaladoLevesOuPesados?: number;
      quantidadeEnvioInstaladoLevesOuPesadosCobliCamGeracao2?: number;
      quantidadeEnvioInstaladoLevesOuPesadosCobliCamGeracao2Pro?: number;
      quantidadeEnvioInstaladoLevesOuPesadosCliente?: number;
      quantidadeEnvioInstaladoLevesOuPesadosCobliCam?: number;
      quantidadeEnvioInstaladoLevesOuPesadosIdentificador?: number;
      quantidadeEnvioInstaladoLevesOuPesadosImobilizador?: number;
      quantidadeEnvioInstaladoMotosOuMaquinarios?: number;
      quantidadeEnvioInstaladoMotosOuMaquinariosCliente?: number;
      quantidadeEnvioRemovivelLeves?: number;
      quantidadeEnvioRemovivelLevesOuPesadosBuzzer?: number;
      quantidadeEnvioRemovivelLevesOuPesadosIdentificador?: number;
      quantidadeEnvioRemovivelPesados?: number;
      quantidadeChaveiro?: number;
    };
  };

  installationInformation: {
    contactInformation: {
      bestWayOfContact: string | null;
      bestTimeToContact: string | null;
      meansToContact: string | null;
      meansToContactTheResponsibleForInstallation: string | null;
    };

    clientInformation: {
      email: string | null;
      phoneNumber: string | null;
      name: string | null;
      responsibleForTrackingScheduling: string | null;
      installationDoneByClient: boolean | null;
      installationProblem: string | null;
    };

    deviceInformation: {
      installationEsns: string | null;
      installationInstalledEsns: string | null;
      installationNotInstalledEsns: string | null;
      type: string | null;
      esnToInstall: string | null;
      esnToNotInstall: string | null;
      heavyOrLightVehiclesInstalledQuantityCoblicam: number | null;
      motorcyclesOrHeavyVehiclesInstalledQuantity: number | null;
      heavyOrLightVehiclesInstalledQuantity: number | null;
      lightVehiclesInstalledBlockerQuantity: number | null;
      heavyOrLightVehiclesInstalledIdentifierQuantity: number | null;
      heavyOrLightVehiclesInstalledImmobilizerQuantity: number | null;
      calculatedInstallDevices: number | null;
      installationDevicesCobliIds: [string];
      installationDevicesIds: [string];
    };

    dateInformation: {
      scheduledDay: string | null;
      clientFirstPreferredScheduleDay: string | null;
      clientSecondPreferredScheduleDay: string | null;
      scheduledDateTime: string | null;
      clientFirstPreferredScheduleHour: string | null;
      clientSecondPreferredScheduleHour: string | null;
      installedDate: string | null;
      installationConfirmedAt: string | null;
    };

    coblerInformation: {
      responsible: string | null;
      responsibleScheduling: string | null;
      responsibleToContactClient: string | null;
      technicalResponsible: string | null;
    };

    fieldControlInformation: {
      worker: string | null;
      fieldControlObservation: string | null;
      observationToTheTechnicalTeam: string | null;
      fieldAssociation: string | null;
      fieldClass: string | null;
      supplyInstalacaoClasse: string | null;
    };

    addressInformation: {
      postalCode: string | null;
      addressConfirmation: string | null;
    };

    vehicleInformation: {
      plack: string | null;
      vehicles: string | null;
    };

    notResponsible: string[] | null;

    responsibleUser: {
      id: string | null;
      name: string | null;
      email: string | null;
      fleetIds: string[] | null;
      createdAt: string | null;
      updatedAt: string | null;
    };

    ratedAt: string | null;
    fleetId: string | null;
    scheduledDay: string | null;
    scheduledDateTime: string | null;
    installedDate: string | null;
    installationConfirmedAt: string | null;
  };

  devolutionInformation: {
    fleetId: string | null;
    fleetName: string | null;
    type: string | null;
    penaltyPrice: number | null;
    devolutionDeadline: string | null;
    supplyDevolucaoTipo: string | null;
    clientInformation: {
      clientCnpj: string | null;
    };

    shippingInformation: {
      devolutionPostageDate: string | null;
      devolutionArrivalOfDevicesAtCobli: string | null;
      devolutionShippingCodeOrScheduleDate: string | null;
      devolutionShippingCode: string | null;
      devolutionShippingType: string | null;
    };

    deviceInformation: DevolutionInformationDeviceInformation;
  };

  servicos: {
    supplyDesinstalacaoCalculoTotal: number | null;
    csAbanQtdDesinstalacao2630Bloqueador: number | null;
    csAbanQtdDesinstalacao2630: number | null;
    quantidadeDesinstalacaoInstaladoLevesOuPesadosCameraFadiga: number | null;
    quantidadeDesinstalacaoInstaladoLevesOuPesadosCameraFadigaPremium: number | null;
    coAbanQtdDesinstalacaoInstaladoVeiculosLevesOuPesadosCliente: number | null;
    coAbanQtdDesinstalacaoInstaladoVeiculosLevesOuPesadosCoblicam: number | null;
    csAbanQtdDesinstalacao2630Ibutton: number | null;
    quantidadeDesinstalacaoInstaladoLevesOuPesadosBuzzer: number | null;
    csAbanQtdDesinstalacao2130: number | null;
    coAbanQtdDesinstalacaoInstaladoMotosOuMaquinariosCliente: number | null;
    csAbanQtdDesinstalacao3030: number | null;
    quantidadeDesinstalacaoRemovivelLevesOuPesadosBuzzer: number | null;
    quantidadeDesinstalacaoRemovivelLevesOuPesadosIdentificador: number | null;
    coAbanQtdDesinstalacaoRemovivelVeiculosPesados: number | null;
  };

  closedDate: string | null;
  content: string | null;
  createDate: string | null;
  conclusionDate: string | null;
  lastActivityDate: string | null;
  lastModifiedDate: string | null;
  nextActivityDate: string | null;
  pipeline: string | null;
  pipelineStage: any;
  priority: string | null;
  notesLastUpdated: string | null;
  notesNextActivityDate: string | null;
  sourceType: string | null;
  subject: string | null;
  ticketAssociatedDealId: string | null;
  resolution: string | null;
  panelFormTest: boolean | null;
}

export interface CrmReportProblemTicket {
  id: string | null;
  createdAt: string | null;
  properties: {
    subject: string | null;
  };
}

export interface CrmReportProblemTicketsDto {
  tickets: CrmReportProblemTicket[];
  total: number;
}

export interface CrmTicketsDto {
  tickets: CrmTicketDto[];
  total: number;
}

export interface CrmSchedulingTicketSummaryDto {
  totalPendingDevolution: number;
  totalScheduled: number;
  totalPendingScheduling: number;
}

export interface UpdateCrmSchedulingFormDto {
  ticketId: string;
  firstPreferredDate: string;
  secondPreferredDate: string;
  thirdPreferredDate: string;
  firstPreferredHour: string;
  secondPreferredHour: string;
  thirdPreferredHour: string;
  licensePlates: string | undefined;
  uf: string;
  city: string;
  zipCode: string;
  neighborhood: string;
  street: string;
  number: string | undefined;
  complement: string | undefined;
  phone: string;
  email: string;
  firstName: string;
  lastName: string;
  bestWayContact: string;
  bestTimeContact: string;
}

export enum PreferredHour {
  MORNING = '08:00 às 10:00',
  LATE_MORNING = '10:00 às 12:00',
  AFTERNOON = '12:00 às 14:00',
  LATE_AFTERNOON = '14:00 às 16:00',
  NIGHT = '16:00 às 18:00',
}

export enum UpsellItem {
  DEVICE = 'device',
  IBUTTON = 'ibutton',
}

export enum CrmTicketsPipeline {
  SERVICES = '263640', // Serviços
  DEVOLUTION = '388863', // Devolução
  SHIPING = '255157', // Envio
}

export enum DevolutionPipelineStage {
  CANCELLED_DEVOLUTION = '941453', // devolução cancelado
  REQUEST_DEVOLUTION = '525139', // Solitação de Devolução
  STAND_BY = '4017858', // Stand by
  WAITING_TECHNICIAN_TO_UNINSTALL = '30093849', // Aguardando técnico desinstalar
  NOT_RETURNED = '388903', // Não serão devolvidos - Em cobrança
  POSTAGE_CODE = '388867', // Código de postagem
  OPENING_TICKET = '93500850', // [DEVOLUÇÃO] - ABERTURA DE TÍQUETE
  CONFIRM_POSTAGE = '388868', // Confirmar postagem
  PARTIAL_DEVOLUTION = '11997579', // Devolução Parcial
  VALIDATION_SUPPORTS = '85094147', // Validação - Suportes
  CLOSING_TICKET = '93500852', // [DEVOLUÇÃO] - Fechamento de tíquete
  WAITING_FOR_CONFERENCES = '388901', // Aguardando Conferência
  NO_SHOW = '115351864', // No show
  CLOSED = '388902', // Concluido
  CONFIRMING_INFORMATION = '388864', // Confirmando informações
  CONTACT_REALIZED_WITH_CUSTOMER = '30093848', // Contato realizado com o cliente
  FILLED_FORM = '183410862', // Formulário preenchido
  SCHEDULE_UNINSTALLATION = '21728796', // Agendar Desinstalação
  TREATING_TICKET = '93500851', // [DEVOLUÇÃO] - Tratativa de tíquete
  ON_THE_WAY = '388900', // A caminho
}

export enum HubServicePipelineStage {
  CLOSED = '499990', // fechados
  CANCELED = '499985', // cancelados
  SCHEDULE_INSTALLATION = '263641', // agendar instalação
  PARTIAL_INSTALLATION = '15284969', // instalação parcial
  INSTALLED = '263650', // instalado
  CANCELED_INSTALLATION = '879589', // instalação cancelada
  NO_SHOW = '34178455', // no show
  CLOSING_TICKET = '46745427', // fechamento de tícket
  TREATING_TICKET = '46745426', // tratativa de ticket
  FILLED_FORM = '127917661', // formulário preenchido
  REQUEST_INSTALLATION = '516896', // solicitação de instalação
  CONTACT_REALIZED_WITH_CUSTOMER = '263648', // contato realizado com o cliente
  AWAITING_FOR_TECHNICIAN_TO_INSTALL = '263649', // aguardando tecnico instalar
  NO_RESPONSE_FROM_CUSTOMER = '5387670', // sem resposta do cliente
}

export enum ShippingSupTechPipelineStage {
  VALIDACAO_SUPORTES = '85125739',
  SOLICITACAO_DE_ENVIO = '455639',
  PEDIDO_REALIZADO = '255158',
  PICKING_LIST = '781456',
  PICKING_REALIZADO = '107694464',
  NOTA_FISCAL_ENVIADA = '255159',
  COLETADO_PELA_TRANSPORTADORA = '255232',
  A_CAMINHO = '255234',
  DISPOSITIVOS_RECEBIDOS = '255236',
  ENVIO_RETORNADO = '848817',
  ENVIO_CANCELADO = '901593',
  ENVIOS_ABERTURA = '99708089',
  ENVIOS_TRATATIVA_DO_TICKET = '99708160',
  ENVIOS_FECHAMENTO_DO_TICKET = '99708161',
}

export enum ShipmentPipelineStageStatus {
  PREPARACAO = 'Preparação',
  EM_TRANSITO = 'Em trânsito',
  ENTREGUE = 'Entregue',
}

export enum SchedulePipelineStageStatus {
  PENDENTE = 'Pendente',
  AGENDADO = 'Agendado',
  CONCLUIDO = 'Concluído',
}

export enum BestWayContact {
  EMAIL = 'E-mail',
  PHONE = 'Telefone',
  WHATSAPP = 'WhatsApp',
}

export enum BestTimeContact {
  MORNING = 'Manhã',
  AFTERNOON = 'Tarde',
}
